"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../api");
var _1 = require(".");
var EventAttendeeSearchField = /** @class */ (function (_super) {
    __extends(EventAttendeeSearchField, _super);
    function EventAttendeeSearchField(api, eventId, label, isRequired, requiredValidationMessage, allowMultipleSelect, key, textKey, searchParams) {
        if (isRequired === void 0) { isRequired = false; }
        if (allowMultipleSelect === void 0) { allowMultipleSelect = false; }
        var _this = _super.call(this, api, label, api_1.EndpointUrls.Events + '/SearchAttendeesForDropdown/' + eventId, 'eventAttendeeId', 'fullName', 'label', isRequired, requiredValidationMessage, allowMultipleSelect, key, textKey ? textKey : 'email', true, searchParams) || this;
        _this.setPlaceholderLabel('Search by name or email address');
        return _this;
    }
    Object.defineProperty(EventAttendeeSearchField.prototype, "visibilityMessage", {
        get: function () {
            return this._visibilityMessage;
        },
        set: function (value) {
            this._visibilityMessage = value;
        },
        enumerable: false,
        configurable: true
    });
    return EventAttendeeSearchField;
}(_1.BaseSearchField));
exports.default = EventAttendeeSearchField;
